<div class="pm-suppliers-container">
    <!-- Breadcrumb -->
    <div class="pm-breadcrumb">
        <a routerLink="/"
            class="breadcrumb-link">Dashboard</a>
        <i class="material-icons breadcrumb-separator">chevron_right</i>
        <a routerLink="/purchase-manager"
            class="breadcrumb-link">Purchase Manager</a>
        <i class="material-icons breadcrumb-separator">chevron_right</i>
        <span class="breadcrumb-current">Suppliers</span>
    </div>

    <div class="suppliers-layout d-flex">
        <!-- Left Sidebar: Supplier List -->
        <div class="suppliers-list-sidebar">
            <div class="search-box p-3">
                <div class="input-group search-input-group">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    <input type="text"
                        class="form-control"
                        placeholder="Search"
                        [(ngModel)]="supplierSearchQuery"
                        (ngModelChange)="onSupplierSearch()">
                </div>
            </div>

            <div class="suppliers-scroll-area">
                <div class="supplier-item d-flex align-items-center p-3"
                    *ngFor="let supplier of filteredSuppliers; trackBy: trackBySupplier"
                    [class.active]="selectedSupplier?.id === supplier.id"
                    (click)="selectSupplier(supplier)">
                    <div class="supplier-avatar me-3">
                        {{ getSupplierInitials(supplier.name) }}
                    </div>
                    <div class="supplier-info flex-grow-1">
                        <div class="d-flex align-items-center">
                            <span class="supplier-name fw-medium">{{ supplier.name }}</span>
                            <i class="fa fa-info-circle ms-2 text-muted-light"
                                *ngIf="supplier.name"></i>
                        </div>
                        <div class="supplier-gstin">GSTIN: {{ getSupplierGst(supplier) }}</div>
                    </div>
                </div>
                <div *ngIf="filteredSuppliers.length === 0 && !isLoading"
                    class="p-4 text-center text-muted">
                    No suppliers found
                </div>
                <div *ngIf="isLoading"
                    class="p-4 text-center">
                    <div class="spinner-border spinner-border-sm text-primary"
                        role="status"></div>
                </div>
            </div>
        </div>

        <!-- Main Content: Items Table -->
        <div class="items-content-area flex-grow-1 p-3">
            <div class="items-header d-flex justify-content-between align-items-center mb-3">
                <div class="items-search">
                    <div class="input-group search-input-group">
                        <span class="input-group-text"><i class="fa fa-search"></i></span>
                        <input type="text"
                            class="form-control"
                            placeholder="Search"
                            [(ngModel)]="itemSearchQuery"
                            (ngModelChange)="onItemSearch()">
                    </div>
                </div>
                <div class="header-actions d-flex gap-2">
                    <button class="btn btn-primary add-supplier-btn"
                        (click)="onAddSupplier()">
                        <i class="fa fa-plus me-1"></i> Add Supplier
                    </button>
                    <button class="btn btn-outline-secondary export-btn"
                        (click)="onExport()">
                        Export
                    </button>
                    <button class="btn btn-outline-secondary add-item-btn"
                        (click)="onAddItem()">
                        <i class="fa fa-plus me-1"></i> Add Item
                    </button>
                    <button class="btn btn-outline-secondary update-rate-btn"
                        (click)="onUpdateRateContract()">
                        <i class="fa fa-refresh me-1"></i> Update Rate Card
                    </button>
                </div>
            </div>

            <div class="table-container bg-white border rounded">
                <table class="table mb-0">
                    <thead>
                        <tr>
                            <th width="40"
                                class="text-center"></th>
                            <th>Item</th>
                            <th>Unit</th>
                            <th>Code</th>
                            <th>Rate</th>
                            <th>Tax Applicable</th>
                            <th>Created Date</th>
                            <th class="text-end">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of filteredRateCardItems; trackBy: trackByItem">
                            <td class="text-center">
                                <i class="material-icons"
                                    [class.text-danger]="item.isFavorite || item.is_favorite"
                                    [class.text-muted-light]="!(item.isFavorite || item.is_favorite)"
                                    style="cursor: pointer; font-size: 18px;"
                                    (click)="onToggleFavorite(item)">
                                    {{ (item.isFavorite || item.is_favorite) ? 'favorite' : 'favorite_border' }}
                                </i>
                            </td>
                            <td>
                                <ng-container *ngIf="editingItemId !== item._id; else editItemName">
                                    {{ item.itemName || item.item_name }}
                                </ng-container>
                                <ng-template #editItemName>
                                    <input type="text"
                                        class="form-control form-control-sm edit-input"
                                        [(ngModel)]="editingItem.itemName"
                                        placeholder="Item Name"
                                        [class.is-invalid]="isFieldInvalid('itemName')">
                                </ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="editingItemId !== item._id; else editUnit">
                                    {{ item.unit || '-' }}
                                </ng-container>
                                <ng-template #editUnit>
                                    <input type="text"
                                        class="form-control form-control-sm edit-input"
                                        [(ngModel)]="editingItem.unit"
                                        (keypress)="onUnitKeyPress($event)"
                                        placeholder="Unit"
                                        [class.is-invalid]="isFieldInvalid('unit')">
                                </ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="editingItemId !== item._id; else editCode">
                                    {{ item.itemCode || item.item_code || '-' }}
                                </ng-container>
                                <ng-template #editCode>
                                    <input type="text"
                                        class="form-control form-control-sm edit-input"
                                        [(ngModel)]="editingItem.itemCode"
                                        placeholder="Code"
                                        [class.is-invalid]="isFieldInvalid('itemCode')">
                                </ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="editingItemId !== item._id; else editRate">
                                    {{ item.rate | number:'1.2-2' }}
                                </ng-container>
                                <ng-template #editRate>
                                    <input type="number"
                                        class="form-control form-control-sm edit-input"
                                        [(ngModel)]="editingItem.rate"
                                        placeholder="Rate"
                                        [class.is-invalid]="isFieldInvalid('rate')">
                                </ng-template>
                            </td>
                            <td>
                                <ng-container *ngIf="editingItemId !== item._id; else editTax">
                                    {{ (item.isTaxApplicable || item.is_tax_applicable) ? 'Yes' : 'No' }}
                                </ng-container>
                                <ng-template #editTax>
                                    <select class="form-select form-select-sm edit-select"
                                        [(ngModel)]="editingItem.isTaxApplicable">
                                        <option [ngValue]="true">Yes</option>
                                        <option [ngValue]="false">No</option>
                                    </select>
                                </ng-template>
                            </td>
                            <td class="text-muted">{{ (item.createdAt || item.created_at) | date:'dd MMM yyyy, HH:mm:ss'
                                }}</td>
                            <td class="text-end">
                                <ng-container *ngIf="editingItemId !== item._id; else saveActions">
                                    <div class="action-buttons">
                                        <button class="btn-icon edit-icon"
                                            (click)="onEditItem(item)"
                                            title="Edit">
                                            <i class="material-icons">edit</i>
                                        </button>
                                        <button class="btn-icon delete-icon"
                                            (click)="onDeleteItem(item)"
                                            title="Delete">
                                            <i class="material-icons">delete_outline</i>
                                        </button>
                                    </div>
                                </ng-container>
                                <ng-template #saveActions>
                                    <div class="edit-actions-vertical">
                                        <button class="btn-icon save-edit-btn"
                                            (click)="onSaveItem()"
                                            title="Save">
                                            <i class="material-icons">check</i>
                                        </button>
                                        <button class="btn-icon cancel-edit-btn"
                                            (click)="onCancelEdit()"
                                            title="Cancel">
                                            <i class="material-icons">close</i>
                                        </button>
                                    </div>
                                </ng-template>
                            </td>
                        </tr>
                        <tr *ngIf="filteredRateCardItems.length === 0 && !isItemsLoading">
                            <td colspan="8"
                                class="text-center p-5 text-muted">
                                No items found for this supplier
                            </td>
                        </tr>
                        <tr *ngIf="isItemsLoading">
                            <td colspan="8"
                                class="text-center p-5">
                                <div class="spinner-border spinner-border-sm text-primary"
                                    role="status"></div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Pagination -->
            <div class="p-3 border-top mt-auto"
                *ngIf="totalItems > 0">
                <app-invoice-pagination [pageSize]="pageSize"
                    [page]="currentPage"
                    [count]="totalItems"
                    pageName="Item"
                    (pageChange)="onPageChange($event)"
                    (pageSizeChange)="onPageSizeChange($event)">
                </app-invoice-pagination>
            </div>
        </div>
    </div>
</div>

<!-- Modals -->
<app-add-rate-card-items-modal #addRateCardItemsModal
    [supplierId]="selectedSupplier?.id || ''"
    [entityId]="selectedEntityId"
    (success)="loadRateCardItems(selectedSupplier?.id || '')">
</app-add-rate-card-items-modal>

<app-add-supplier-rate-card-file-modal #addSupplierRateCardFileModal
    (supplierAdded)="onSupplierAdded($event)">
</app-add-supplier-rate-card-file-modal>